<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ handleSubmit }">
    <form
      class="path-activity-form"
      @submit.prevent="handleSubmit(onSubmit)">
      <label
        class="col-form-label">
        活動日
      </label>
      <BaseDatepickerWithProvider
        v-model="form.activityAt"
        name="活動日"
        vid="activityAt"
        class="mb-4"
        placeholder="活動日を選択してください" />
      <label
        class="col-form-label">
        活動内容
      </label>
      <BaseTextareaWithProvider
        v-model="form.description"
        name="活動内容"
        vid="description"
        placeholder="活動内容を入力してください"
        rows="3" />
      <div
        class="d-flex justify-content-between mt-4"
        style="gap: 16px;">
        <button
          type="button"
          class="btn btn-block btn-cancel"
          @click="onClickCancel">
          キャンセル
        </button>
        <b-button
          type="submit"
          variant="primary"
          class="w-100">
          保存
        </b-button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import BaseDatepickerWithProvider from '@/components/parts/BaseDatepickerWithProvider.vue'
import BaseTextareaWithProvider from '@/components/parts/BaseTextareaWithProvider.vue'
import { format } from 'date-fns'
export default {
  components: {
    BaseDatepickerWithProvider,
    BaseTextareaWithProvider
  },
  props: {
    userId: {
      type: String,
      required: true
    },
    pathActivity: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        user: this.userId,
        description: '',
        activityAt: format(new Date(), 'yyyy-MM-dd')
      }
    }
  },
  created() {
    if (this.pathActivity) {
      this.form = {
        userId: this.pathActivity.user.id,
        description: this.pathActivity.description,
        activityAt: format(new Date(this.pathActivity.activityAt), 'yyyy-MM-dd')
      }
    }
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.form)
    },
    onClickCancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style>

</style>